import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { PersonRemoveStoreCreditPage } from 'src/app/modals/person-remove-store-credit/person-remove-store-credit.page';

const routes: Routes = [
  {
    path: '',
    component: PersonRemoveStoreCreditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [PersonRemoveStoreCreditPage]
})
export class PersonRemoveStoreCreditPageModule {}
